import { FileUploader } from '@emerald-works-nova/components'
import { Folder, FolderOpenOutlined } from '@mui/icons-material'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { TenantEditSlice } from '../../../../reducers'
import validator from './validator'

const MAX_SIZE = 200

const Label = () => <>Drop <strong>CSV file</strong> here to upload or{' '}</>

const Description = ({ file, tenant }) => {
  if (file) {
    return (
      <span>
        All users listed in this file will be <strong>DELETED</strong> from the {tenant.name} Toolkit
      </span>
    )
  }
  return `Max file size ${MAX_SIZE} MB`
}

const UploadInput = ({ onAccept, onValidation = () => { } }) => {
  const tenant = useSelector(TenantEditSlice.selectors.tenant)

  const [file, setFile] = useState()

  const handleDropAccepted = file => {
    setFile(file)
    onAccept(file)
  }

  const handleValidation = async (file) => {
    const result = await validator(file)
    if (result.code) {
      return result
    } else {
      onValidation(result)
    }
  }

  return (
    <FileUploader
      label={file ? file.name : <Label />}
      maxSize={MAX_SIZE * 1024 * 1024}
      description={<Description file={file} tenant={tenant} />}
      Icon={file ? Folder : FolderOpenOutlined}
      accept='.csv'
      fileNamePrefix={`bulk-user-delete/${tenant.pk}/`}
      onDropAccepted={handleDropAccepted}
      articleBodyUploader
      validator={handleValidation}
      storageOpts={{ level: 'private' }}
      dataTest='bulk-user-delete-csv-file-uploader'
    />
  )
}

export default UploadInput
